import { ReactComponents } from "@tumbodash/browserPackages";
import type { Party } from "../../../types.js";

interface NavbarProps {
	party?: Party;
	children?: React.ReactNode;
}

function Navbar({ children }: NavbarProps) {
	return (
		<nav style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			padding: "var(--space-3) var(--space-4)",
			borderBottom: "1px solid var(--border)",
			background: "var(--bg-base)",
			position: "sticky",
			top: 0,
			zIndex: 10,
		}}>
			<ReactComponents.Logo />
			<div>{children}</div>
		</nav>
	);
}

export default Navbar;
